<template>
  <div class="space-info">
    <SidebarHeader
    class="space-info-header"
    :menuItems="[
    {
      icon: 'edit',
      text: 'Edit information panel',
      show: userLevel > 0,
      click: goToCustomise
    }
    ]"
    >
      <template #title>
        {{spaceName}}
        <h4 class="space-info-header__company">
          <span v-if="companyName">{{companyName}} </span>
          <span class="space-type">
            <i>{{isOpenSpace ? 'Open Space' : 'Private Space'}}</i>
          </span>
        </h4>
      </template>
    </SidebarHeader>

    <div class="space-info-content">
      <div class="space-info-info">
        <b>{{infoHeading}}</b>
        <br v-if="infoDescription"/><br v-if="infoDescription"/>
        {{infoDescription}}
      </div>

      <div class="space-info-box space-info-number">
        <img src="@/assets/global-icons/user-circle.svg"/>
        <b>{{usersOnline}} Online in this Space</b>
      </div>

      <button v-if="isOpenSpace" @click="inviteExternalUser" class="space-info-box invite-external">
        <div>
          <b>Invite to Space</b>
          <p>Invite external guests</p>
        </div>
        <img src="@/assets/settings-icons/invite-user-green.svg" aria-hidden="true"/>
      </button>

      <div class="space-info-box become-member" v-if="isOpenSpace && isGuest" @click="registerAsGuestHandler" >
        <div>
          <b>Signup to become a registered SPACEIN user</b>
        </div>
        <img src="@/assets/global-icons/lightbulb.svg"/>
      </div>
      <div class="space-info-box become-member" v-else-if="isOpenSpace && isRegisteredGuest" @click="handleAddOpenSpaceToCollection" >
        <div>
          <b>Add this Space to your Spaces Collection</b>
        </div>
        <img src="@/assets/global-icons/lightbulb.svg"/>
      </div>

      <a
      class="space-info-box space-info-help"
      href="https://mccglc.atlassian.net/servicedesk/customer/portal/2/group/3/create/18"
      target="_blank"
      >
        <div>
          <b>Need help?</b>
          <br/>
          SPACEIN service desk
        </div>
        <img src="@/assets/sidebar-icons/help.svg"/>
      </a>

      <div class="space-info__copyright">
        &copy; MCCGLC Ltd {{new Date().getFullYear()}}. All rights reserved.
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import SidebarHeader from '../SidebarHeader.vue';
import InviteExternalSpaceGuestsModal from '@/components/modals/admin/InviteExternalSpaceGuestsModal.vue';

export default {
  name: 'space-info',
  components: { SidebarHeader },
  computed: {
    ...mapGetters({
      spaceInfo: 'getCurrentAreaInfo',
      spaceName: 'getCurrentAreaTitle',
      companyName: 'getCurrentAreaCompanyName',
      usersOnline: 'getCurrentAreaActiveUsersNo',
      userLevel: 'current_user/currentAreaPermissionNo',
      isMobile: 'viewport/isMobile',
      isOpenSpace: 'isOpenSpace',
      isRegisteredGuest: 'current_user/isGuest',
      isGuest: 'current_user/isExternalGuest',
    }),
    infoHeading: vm => vm.spaceInfo?.heading || 'Welcome!',
    infoDescription: vm => vm.spaceInfo?.description || (vm.userLevel > 0 ? 'As an admin of this Space you can edit the title, description and background image of this space with the menu in the top-right.' : '')
  },
  methods: {
    ...mapActions(['routing/goToCustomise', 'sidebar/close']),
    ...mapActions('guest/space', ['handleAddOpenSpaceToCollection', 'inviteExternalUser']),
    ...mapActions(['modal/open']),
    ...mapActions('guest', ['registerAsGuestHandler']),
    goToCustomise(){
      this['routing/goToCustomise']()

      if(this.isMobile) this['sidebar/close']()
    },
    inviteExternalUser() {
      this['modal/open']([InviteExternalSpaceGuestsModal])
    }
  }
}
</script>

<style scoped lang="scss">
.space-info {
  color: #B3B3B3;
  line-height: 1;
  display: flex;
  flex-flow: column;
  height: 100%;
  box-sizing: border-box;

  b {
    color: white;
  }

  &-header {
    box-shadow: none !important;

    &__company {
      margin-top: 2px;
      font-size: 0.9rem;

      & .space-type {
        color: #B3B3B3;
        font-weight: normal;
      }
    }
  }

  &-content {
    padding: 20px;
    display: flex;
    flex-flow: column;
    height: 100%;
    box-sizing: border-box;
  }

  &-box {
    margin-bottom: 20px;
    background-color: $grey-6;
    padding: 20px;
    border-radius: 17px;
  }

  &-info {
    line-height: 1.2;
    margin-top: 1rem;
    margin-bottom: 4rem;
    color: white;
  }

  &-number {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 10px;
    padding: 15px 20px;
    font-size: 14px;
  }

  &-help, .become-member {
    text-decoration: none;
    display: flex;
    justify-content: space-between;
    color: #B3B3B3;
    align-items: center;
    line-height: 1.4;
    cursor: pointer;
  }
  & .invite-external {
    cursor: pointer;
    width: 100%;
    color: white;
    font-size: 0.875rem; /** 14px*/
    padding: 20px 18px;
    display: grid;
    grid-auto-flow: column;
    justify-content: stretch;
    align-items: center;
    border: none;
    gap: 10px;
    transition: background-color 0.2s;

    & img {
      justify-self: flex-end;
    }

    & div {
      display: flex;
      flex-direction: column;
      gap: 0.2rem;
      text-align: left;

      & p {
        font-size: 0.8rem; /** 14px*/
        color: $grey-2;
      }
    }

    &:hover {
      background-color: $active-user-room;

      & p {
        color: white !important;
      }
      & img {
        filter: brightness(1000%);
      }
    }
    @include mobile-only {
      background-color: $active-user-room;

      & p {
        color: white !important;
      }
      & img {
        filter: brightness(1000%);
      }
    }
  }

  &__copyright {
    font-size: 13px;
    // parent is set to display: flex to get this to work
    margin-top: auto;
  }
}
</style>
